import { styled } from 'styled-components';
import { tk } from '@sunwebgroup/ui-components';

export const Card = styled.div`
  background-color: ${tk('color_semantic_bg')};
  border-radius: ${tk('radius_large')};
  overflow: hidden;
  box-shadow: ${tk('shadow_md_bottom')};
`;
